var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BrandedHorizontalSplitLayoutDesktop from "./breakpoints/desktop/branded-horizontal-split-layout.desktop";
import BrandedHorizontalSplitLayoutMobile from "./breakpoints/mobile/branded-horizontal-split-layout.mobile";
import { useBreakpoint } from "../common/hooks/useBreakpoint";
export var BrandedHorizontalSplitLayout = function (props) {
    var isDesktopOrLaptop = useBreakpoint().isDesktopOrLaptop;
    if (isDesktopOrLaptop) {
        return _jsx(BrandedHorizontalSplitLayoutDesktop, __assign({}, props));
    }
    else {
        return _jsx(BrandedHorizontalSplitLayoutMobile, __assign({}, props));
    }
};
export default BrandedHorizontalSplitLayout;
